<template>
  <div class="map-container">
    <gmap-map :center="center" :zoom="internalzoom" :style="{ height, width }">
      <gmap-marker id="marker"
                   :position="center"
                   :draggable="draggableMarker"
                   @dragend="drag"></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
import { Cosinesimilarity, LevenshteinDistance } from '../../../mixins/cosineSimil';

export default {
  name: 'MapByGeo',
  data() {
    return {
      location: this.value,
      internalzoom: this.zoom,
    };
  },
  props: {
    raw_address: {
      type: String,
      default: 'Barcelona 165',
    },
    value: {
      type: Object,
      default() {
        return {
          address: '',
          position: {
            lat: -33.435774, // TODO: FIXME
            lng: -70.660690,
          },
          commune: '',
          locality: '',
          route: '',
          street_number: '',
        };
      },
    },
    latlng: {},
    zoom: {
      type: Number,
      default: 10,
    },
    height: {
      type: String,
      default: '30vh',
    },
    width: {
      type: String,
      default: '100%',
    },
    draggableMarker: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    center() {
      return this.value.position;
    },
  },
  methods: {
    dot(address) {
      const realAdress = address.formatted_address.split(',')[0];
      return Cosinesimilarity(this.raw_address.toLowerCase(), realAdress.toLowerCase());
    },
    levenshtein(address) {
      const realAdress = address.formatted_address.split(',')[0];
      return LevenshteinDistance(this.raw_address.toLowerCase(), realAdress.toLowerCase());
    },
    getLocation() {
      return this.location;
    },
    setAll() {
      const self = this;
      this.$gmapApiPromiseLazy().then((response) => {
        const latlng = {
          lat: parseFloat(this.location.position.lat),
          lng: parseFloat(this.location.position.lng),
        };
        const geocoder = new response.maps.Geocoder();
        // eslint-disable-next-line
        geocoder.geocode({ 'location': latlng }, (results, status) => {
          const dotFilter = results.filter(a => this.dot(a) > 0);
          const selectedResult = results[0];
          if (dotFilter.length > 0) {
            Object.assign(selectedResult,
              dotFilter.sort((a, b) => this.levenshtein(a) - this.levenshtein(b))[0]);
          }
          self.location.address = selectedResult.formatted_address;
          const streetAddress = selectedResult.address_components.filter(val => val.types.findIndex(el => el === 'street_address') >= 0);
          if (streetAddress.length > 0) {
            const routes = streetAddress[0].address_components.filter(val => val.types.findIndex(el => el === 'route') >= 0);
            const streetNumbers = streetAddress[0].address_components.filter(val => val.types.findIndex(el => el === 'street_number') >= 0);
            if (routes.length > 0) {
              self.location.route = routes[0].long_name;
            }
            if (streetNumbers.length > 0) {
              self.location.street_number = streetNumbers[0].long_name;
            }
          }
          const locality = results.filter(val => val.types.findIndex(el => el === 'locality') >= 0);
          const commune = results.filter(val => val.types.findIndex(el => el === 'administrative_area_level_3') >= 0);
          if (commune.length > 0) {
            self.location.commune = commune[0].address_components[0].long_name;
            self.location.locality = commune[0].address_components[0].long_name;
          }
          if (locality.length > 0) {
            self.location.locality = locality[0].address_components[0].long_name;
          }
        });
        this.internalzoom = 13;
        // this.$emit('input', self.location);
      }).catch(() => {
      });
    },
    drag() {
      this.location.position.lat = this.$children[0].$children[0].$markerObject.position.lat();
      this.location.position.lng = this.$children[0].$children[0].$markerObject.position.lng();
      this.setAll();
      this.$emit('input', this.getLocation());
    },
  },
  watch: {
    value() {
      this.location = this.value;
    },
    latlng: {
      handler(val) {
        this.location.position = val;
        this.setAll();
      },
    },
    zoom: {
      handler(val) {
        this.internalzoom = val;
      },
    },
  },
};
</script>

<style scoped>

</style>
